import { ERROR_TYPES, createAuthService } from '@maple-tech/auth';
import { redirect } from 'react-router-dom';
/*
  get(key: string): string | null
  getAll(): string[][] // entries [key,value][]
  del(key: string): string
  set(key: string, value: string): void
  // put(key: string, value: string): void
  clearAll(): void

  coreAPI: string
  retailAPI: string

  onError: (error: ERROR_TYPES, ...args: any) => void
  onLoginSuccess: () => void
  onAuthLogout: () => void 
  onSessionExpired: () => void
  apisRegistry:Record<string, string>

*/
const isDev = false;
// const isDev = import.meta.env.MODE !== "production";

const $HOST_AUTH = isDev
  ? // ? 'http://localhost:6556'
    'https://auth.workmaple.dev'
  : 'https://stg-auth.workmaple.com';
const $HOST_CORE = isDev
  ? // ? 'http://localhost:8082'
    'https://core-api.workmaple.dev'
  : 'https://stg-core-api.workmaple.com';
const $HOST_CORE_V2 = isDev
  ? // ? 'http://localhost:6709/api/v1'
    'https://core-api-v2.workmaple.dev/api/v1'
  : 'https://stg-core-api-v2.workmaple.com/api/v1';
const $HOST_RETAIL = isDev
  ? // ? 'http://localhost:8083'
    'https://retail-api.workmaple.dev'
  : 'https://stg-retail-api.workmaple.com';
const $HOST_RETAIL_V2 = isDev
  ? // ? 'http://localhost:6396/api/v1'
    'https://retail-api-v2.workmaple.dev/api/v1'
  : 'https://stg-retail-api-v2.workmaple.com/api/v1';
const $HOST_DOCUMENTS = isDev
  ? // ? 'http://localhost:8085'
    'https://documents-api.workmaple.dev/api/v2'
  : 'https://stg-documents-api.workmaple.com';
const $HOST_DOCUMENTS_V2 = isDev
  ? // ? 'http://localhost:8987/api/v2'
    'https://documents-api.workmaple.dev/api/v2'
  : 'https://stg-documents-api-v2.workmaple.com/api/v2';
const $HOST_AUTOMATORS = isDev
  ? // ? 'http://localhost:8084'
    'https://automator.workmaple.dev'
  : 'https://stg-automator-api.workmaple.com';
const $HOST_MODULES = isDev
  ? // ? 'http://localhost:8099/api/v1'
    'https://modules-api.workmaple.dev/api/v1'
  : 'https://stg-modules-api.workmaple.com/api/v1';

const $HOST_TASK = isDev
  ? 'https://task-api.workmaple.dev/api/v1'
  : 'https://stg-task-api.workmaple.com/api/v1';

const $HOST_VM = isDev
  ? 'https://visual-merchandising-api.workmaple.dev/api/v1'
  : 'https://stg-vm-api.workmaple.com/api/v1';

const apiList = new Map([
  ['ModulesAPI', $HOST_MODULES],
  ['CoreAPI', $HOST_CORE],
  ['CoreAPIV2', $HOST_CORE_V2],
  ['RetailAPI', $HOST_RETAIL],
  ['RetailAPIV2', $HOST_RETAIL_V2],
  ['AuthAPI', $HOST_AUTH],
  ['DocumentsAPI', $HOST_DOCUMENTS],
  ['DocumentsAPIV2', $HOST_DOCUMENTS_V2],
  ['AutomatorsAPI', $HOST_AUTOMATORS],
  ['TaskAPI', $HOST_TASK],
  ['VMAPI', $HOST_VM],
]);
console.log('apiList', apiList, isDev);
// Create Service
export const authService = createAuthService({
  storage: {
    get: (key: string): string | null => {
      return localStorage.getItem(key);
    },
    getAll: (): string[][] => {
      return Object.entries(localStorage);
    },
    del: (key: string): string => {
      const deletedValue = localStorage.getItem(key);
      if (!deletedValue) return '';
      localStorage.removeItem(key);
      return deletedValue || '';
    },
    set: (key: string, value: string): void => {
      localStorage.setItem(key, value);
    },
    clearAll: (): void => {
      localStorage.clear();
      redirect('/login');
    },
  },
  onError: (
    error: ERROR_TYPES,
    ...args: (string | number | boolean | Date)[]
  ) => {
    console.warn('onError', error, args);
  },
  onLoginSuccess: () => {
    console.info('onLoginSuccess');
    if (window.location.pathname === '/login') {
      redirect('/');
    }
  },
  onAuthLogout: () => {
    console.info('onAuthLogout');
    localStorage.clear();
    if (window.location.pathname != '/login') {
      redirect('/login');
    }
  },
  onSessionExpired: () => {
    console.info('onSessionExpired');
    localStorage.clear();
    if (window.location.pathname != '/login') {
      redirect('/login');
    }
  },
  userStorageKey: '@maple/userData',
  apisRegistry: apiList,
});

if (isDev) {
  // @ts-ignore
  window.maple = {};
  for (const [key, value] of apiList) {
    // @ts-ignore
    window.maple[key] = authService?.getInstance(key);
  }
}
